import { render, staticRenderFns } from "./DebugLogPanel.vue?vue&type=template&id=0880be7c&scoped=true"
import script from "./DebugLogPanel.vue?vue&type=script&lang=js"
export * from "./DebugLogPanel.vue?vue&type=script&lang=js"
import style0 from "./DebugLogPanel.vue?vue&type=style&index=0&id=0880be7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880be7c",
  null
  
)

export default component.exports